import React, { useState, useEffect, useRef } from "react";
import { Bell, HelpCircle } from "lucide-react";
import "./Header.css";

const Header = ({ username }) => {
  const [scrolled, setScrolled] = useState(false);
  const [showNotifDropdown, setShowNotifDropdown] = useState(false);
  const [showHelpDropdown, setShowHelpDropdown] = useState(false);
  const [hasUnseen, setHasUnseen] = useState(true);

  const lastUpdated = "";
  const [devMessage, setDevMessage] = useState("App Under Development");

  const notifRef = useRef(null);
  const helpRef = useRef(null);

  // Show red dot when message changes
  useEffect(() => {
    setHasUnseen(true);
  }, [devMessage]);

  // Sticky header scroll handling
  useEffect(() => {
    const scrollContainer = document.querySelector(".dashboard-scroll");
    if (scrollContainer) {
      const handleScroll = (e) => {
        setScrolled(e.target.scrollTop > 0);
        setShowNotifDropdown(false);
        setShowHelpDropdown(false);
      };
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }
  }, []);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notifRef.current &&
        !notifRef.current.contains(event.target) &&
        helpRef.current &&
        !helpRef.current.contains(event.target)
      ) {
        setShowNotifDropdown(false);
        setShowHelpDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleBellClick = (e) => {
    e.stopPropagation();
    setShowNotifDropdown((prev) => !prev);
    setShowHelpDropdown(false);
    setHasUnseen(false);
  };

  const handleHelpClick = (e) => {
    e.stopPropagation();
    setShowHelpDropdown((prev) => !prev);
    setShowNotifDropdown(false);
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-left">
        <div className="avatar">
          <span>👤</span>
        </div>
        <span className="username">{username}</span>
      </div>

      <div className="header-right">
        {/* 🔔 Notifications */}
        <div className="notif-wrapper" ref={notifRef}>
          <Bell
            size={25}
            className="icon bell-icon"
            onClick={handleBellClick}
          />
          {hasUnseen && <span className="notif-dot" />}

          {showNotifDropdown && (
            <div className="notif-dropdown">
              <p className="notif-heading">Notifications</p>

              <div className="notif-item">
                <span className="notif-label">Data Last Updated:</span>
                <span className="notif-value">{lastUpdated}</span>
              </div>

              <div className="notif-item">
                <span className="notif-label">Dev Message:</span>
                <span className="notif-value">{devMessage}</span>
              </div>
            </div>
          )}
        </div>

        {/* ❔ Help Section */}
        <div className="help-wrapper" ref={helpRef}>
          <HelpCircle
            size={25}
            className="icon help-icon"
            onClick={handleHelpClick}
          />
          {showHelpDropdown && (
            <div className="help-dropdown">
              <p className="help-heading">Page Guide</p>
              <ul className="help-list">
                <li><strong>Home:</strong> Overview of key metrics and performance insights for your posts in the past 30 days.</li>
                <li><strong>Analytics:</strong> Deep dive into post-level metrics, graphs, and trends.</li>
                <li><strong>Profile:</strong> Manage your account.</li>
                <li><strong>Export:</strong> Download Filtered data that is displayed as Excel reports.</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
